import { render, staticRenderFns } from "./OrganizationProfileCard.vue?vue&type=template&id=3fc20d8e&scoped=true&"
import script from "./OrganizationProfileCard.vue?vue&type=script&lang=js&"
export * from "./OrganizationProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationProfileCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrganizationProfileCard.vue?vue&type=style&index=1&id=3fc20d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc20d8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
